import STORE_CONST from '../consts'
import documentApi from '../../api/document'

const state = {
  document: []
}

const mutations = {
  [STORE_CONST.DOCUMENT.GET_LIST] (state, list) {
    state.document = list
  }
}

const actions = {
  [STORE_CONST.DOCUMENT.GET_LIST] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      documentApi.getDocumentList(params).then(res => {
        commit(STORE_CONST.DOCUMENT.GET_LIST, res.data.objects)
        resolve(res.data)
      })
    })
  },
  [STORE_CONST.DOCUMENT.DEL] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      documentApi.delDocument(params).then(res => {
        resolve(res.data)
      })
    })
  },
  [STORE_CONST.DOCUMENT.UPLOAD] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      documentApi.uploadFile(params).then(res => {
        resolve(res.data)
      })
    })
  }
}

const getters = {
  document: state => {
    return state.document
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/document.js